import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import Heading from '../../../../components/Heading';
import './styles.scss';
import Filters from './components/Filters';
import Table from './components/Table';
import { useAcceptHireRequests } from '../../../../reactQuery/violations';
import { useCustomParams } from '../../../../hooks/useCustomParams';
import PendingActionsOutlinedIcon from '../../../../styles/svg/hire-us-request.svg'


const PendingRequests = () => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [filter, setFilter] = useState('total');
  const [search] = useCustomParams('search');
  const { isLoading, error, responseData, isError, refetch, totalRecords } =
    useAcceptHireRequests({
      page: page +1,
      pageSize: pageSize,
      search: search,
      status: filter,
    });

  // Simulate loading effect
  useEffect(() => {
    refetch();
  }, [filter, page, pageSize, search]);

  return (
    <div className="pending-requests-container">
      <Heading title="Hire Us Requests" icon={PendingActionsOutlinedIcon}>
        {/* Add buttons here if needed */}
      </Heading>

      <div className="mt-4">
        <Filters
          filter={filter}
          setFilter={setFilter}
          totalRecords={totalRecords}
        />

        <div className="">
          <Table
            isLoading={isLoading}
            data={responseData || []}
            page={page}
            pageSize={pageSize}
            setPage={setPage}
            setPageSize={setPageSize}
            totalRecords={totalRecords}
            refetch={refetch}
          />
        </div>
      </div>
    </div>
  );
};

export default PendingRequests; 